/**
 * PendingProposals — 25/02/2026
 *
 * Página dedicada ao painel simétrico do DAF: propostas por aceitar.
 * Mostra todos os leads onde a proposta já foi enviada mas o cliente
 * ainda não adjudicou, com aging por dias-desde-envio e um campo por
 * linha para o Consultor(a) justificar cada caso.
 */

import PendingProposalsPanel from "@/components/PendingProposalsPanel";
import RTProposalsReport from "@/components/RTProposalsReport";
import { Info } from "lucide-react";

export default function PendingProposals() {
  return (
    <div className="space-y-6" data-testid="pending-proposals-page">
      <header className="space-y-1">
        <div className="text-[10px] uppercase tracking-[0.22em] text-muted-foreground font-semibold">
          Follow-up de Propostas
        </div>
        <h1 className="text-2xl font-ui text-foreground">Propostas por aceitar</h1>
        <p className="text-sm text-muted-foreground max-w-2xl">
          Clientes que já receberam a proposta mas ainda não deram resposta.
          Cada Consultor(a) justifica o estado da conversa para a Direcção
          perceber o que está a bloquear a decisão.
        </p>
      </header>

      <PendingProposalsPanel />

      <RTProposalsReport />

      <div
        className="rounded-2xl border border-[hsl(var(--info))]/20 bg-[hsl(var(--info-bg))]/50 px-5 py-4 flex items-start gap-3"
        data-testid="pending-proposals-info-callout"
      >
        <div className="p-1.5 rounded-full bg-[hsl(var(--info))]/15 text-[hsl(var(--info))]">
          <Info className="w-4 h-4" />
        </div>
        <div className="text-xs text-muted-foreground leading-relaxed">
          <div className="text-foreground font-semibold mb-0.5">Como usar este painel</div>
          Escreve na coluna "Justificação do Consultor" o estado real da conversa
          com o cliente (ex: "cliente pediu tempo até 20/08 para consultar filha",
          "vai comparar com concorrência", "ainda a decidir orçamento"). O texto
          fica registado com autor e data — a Direcção usa esta informação
          para prever ganhos e detectar deals parados.
        </div>
      </div>
    </div>
  );
}
